// Mirrors src/lib/radio-now-playing.ts (which carries the unit tests). Keep in sync.
// common shapes (AzuraCast, Icecast status-json, generic) and degrades to null
// so an unknown or failed feed simply shows the scheduled show instead. Pure +
// unit-tested; mirrored into web/src/lib.

export type LiveTrack = { text: string; title?: string; artist?: string; art?: string };

export function parseNowPlaying(json: unknown): LiveTrack | null {
  if (!json || typeof json !== "object") return null;
  const j = json as Record<string, unknown>;

  // AzuraCast: { now_playing: { song: { text, title, artist, art } } }
  const song = (j.now_playing as Record<string, unknown> | undefined)?.song as
    | Record<string, unknown>
    | undefined;
  if (song) {
    const artist = str(song.artist);
    const title = str(song.title);
    const text = str(song.text) || [artist, title].filter(Boolean).join(", ");
    if (text.trim()) return { text: text.trim(), title, artist, art: str(song.art) || undefined };
  }

  // Icecast status-json.xsl: { icestats: { source: {title} | [{title}] } }
  const source = (j.icestats as Record<string, unknown> | undefined)?.source;
  const first = Array.isArray(source) ? source[0] : source;
  const icTitle = str((first as Record<string, unknown> | undefined)?.title);
  if (icTitle.trim()) return { text: icTitle.trim() };

  // Generic { title } / { artist, title }
  const title = str(j.title);
  if (title.trim()) {
    const artist = str(j.artist);
    return { text: [artist, title].filter(Boolean).join(", ").trim(), title, artist: artist || undefined };
  }

  return null;
}

function str(v: unknown): string {
  return typeof v === "string" ? v : "";
}
